/**
 * Entity type enumeration
 */
export enum EntityType {
  User = 1,
  Role = 2,
  Collection = 3,
  DataSource = 4,
  Project = 5,
  Goal = 6
}
